import * as React from "react";

function MultiUsers(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 22 20" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 .25a4.75 4.75 0 100 9.5 4.75 4.75 0 000-9.5zM4.75 5a3.25 3.25 0 116.5 0 3.25 3.25 0 01-6.5 0z"
        fill="currentColor"
      />
      <path
        d="M14 .25a.75.75 0 000 1.5 3.25 3.25 0 010 6.5.75.75 0 000 1.5 4.75 4.75 0 100-9.5z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M.25 17A5.75 5.75 0 016 11.25h4A5.75 5.75 0 0115.75 17 2.75 2.75 0 0113 19.75H3A2.75 2.75 0 01.25 17zM6 12.75A4.25 4.25 0 001.75 17c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25A4.25 4.25 0 0010 12.75H6z"
        fill="currentColor"
      />
      <path
        d="M16 11.25a.75.75 0 000 1.5A4.25 4.25 0 0120.25 17c0 .69-.56 1.25-1.25 1.25h-1.5a.75.75 0 000 1.5H19A2.75 2.75 0 0021.75 17 5.75 5.75 0 0016 11.25z"
        fill="currentColor"
      />
    </svg>
  );
}

const MemoMultiUsers = React.memo(MultiUsers);
export default MemoMultiUsers;
